import { TFeature } from 'shared/map-search/types/map';

interface ICheckIsHoverablePointProps {
  selectedFeature: TFeature | null;
  currentFeature: TFeature;
}

/**
 * @description
 * Проверяет, можно ли обрабатывать hover на пине
 */
export const checkIsHoverablePoint = ({ selectedFeature, currentFeature }: ICheckIsHoverablePointProps) => {
  const isSelectedFeature = selectedFeature?.id === currentFeature.id;
  const isExtendedFeature = currentFeature.properties.isExtended;

  return !isSelectedFeature && !isExtendedFeature;
};
